import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { FileTypeServiceConfig } from './file-type-service.types';

export function provideFileTypeService(config: FileTypeServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'fileTypeServiceConfig', useValue: config }
  ]);
}
